module.exports = __webpack_public_path__ + "img/waves-white.634c6eb9.svg";